import {BookingInitial} from '../Booking/BookingInitial/BookingInitial';
import {useBookingContext} from 'src/context/BookingContext';
import {BookingTime} from '../Booking/BookingTime/BookingTime';
import {PeopleMain} from 'src/components/clinic/booking/people-select/PeopleMain';
import {BookingConsent} from 'src/components/clinic/booking/booking-consent/BookingConsent';
import {BookingHealthDeclaration} from 'src/components/clinic/booking/booking-health-declaration/BookingHealthDeclaration';
import {BookingConfirm} from 'src/components/clinic/booking/booking-confirm/BookingConfirm';
import {BookingCompleted} from 'src/components/clinic/booking/booking-completed/BookingCompleted';
import {BookingInformation} from '../Booking/BookingInformation/BookingInformation';
import {DropInConfirm} from 'src/components/clinic/dropin/dropin-confirm/DropInConfirm';
import {DropInCompleted} from 'src/components/clinic/dropin/dropin-completed/DropInCompleted';
import {DropInPeople} from '../DropIn/DropInPeople/DropInPeople';

export function LocationMain() {
    const {bookingState} = useBookingContext();
    const {step, bookingType} = bookingState;

    const stepComponent = () => {
        if (bookingType === 'booking') {
            switch (step) {
                case 'initial':
                    return <BookingInitial />;
                case 'information':
                    return <BookingInformation />;
                case 'timeSelect':
                    return <BookingTime />;
                case 'peopleSelect':
                    // From here on we have a clinic ID, share the rest of the steps with clinic booking
                    return <PeopleMain />;
                case 'consent':
                    return <BookingConsent />;
                case 'healthDeclaration':
                    return <BookingHealthDeclaration />;
                case 'confirm':
                    return <BookingConfirm />;
                case 'completed':
                    return <BookingCompleted />;
            }
        } else if (bookingType === 'dropIn' || bookingType === 'healthDeclaration') {
            switch (step) {
                case 'initial':
                    return <BookingInitial />;
                case 'peopleSelect':
                    // Pick out the first location stop and use this stop's clinic
                    // From here on we have a clinic, share the rest of the steps with clinic booking
                    return <DropInPeople />;
                case 'healthDeclaration':
                    return <BookingHealthDeclaration />;
                case 'confirm':
                    return <DropInConfirm />;
                case 'completed':
                    return <DropInCompleted />;
            }
        }
    };

    return <>{stepComponent()}</>;
}
